
import '@/styles/pages/index-mobile/index.css'
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // 入口文件
/* eslint-disable */

new Vue({
  data() {
    return {
      isIOS: true
    }
  },
  created($, apower) {
    dealDownload()
    function dealDownload() {
      var isIpad = (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      var isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent) || isIpad

      var downloadHref = 'https://play.google.com/store/apps/details?id=com.apowersoft.gitmind'
      if (isIOS) {
        downloadHref = 'https://download.aoscdn.com/down.php?softid=gitmind&os=ios'
      }
      for (let i = 0; i < $('.download').length; i++) {
        $('.download').attr('href', downloadHref)
      }
      window.dispatchEvent(new Event('wx_update_download_link'))
    }

    // 获取页面cookie
    function getCookieAtr(type) {
      var atr = type + '='
      var arr = document.cookie.split(';')
      for (var i = 0; i < arr.length; i++) {
        var str = arr[i].trim()
        if (0 == str.indexOf(atr)) {
          return str.substring(atr.length, str.length)
        }
      }
      return ''
    }
    // 阿里云追踪请求
    function track(trackParams) {
      var productId = '343'
      var trackUrl =
        'https://wx-user-behavior.cn-hongkong.log.aliyuncs.com/logstores/' +
        productId +
        '/track?APIVersion=0.6.0'
      $.get(trackUrl, trackParams)
    }
    // 参数处理
    function dealTrackParams(e) {
      var str = e.dataset.trackParams
      var trackParams = {}
      if (str) {
        var arr
        str.split('&').forEach(function (e) {
          arr = e.split('=')
          trackParams[arr[0]] = arr[1]
        })
      }
      trackParams.source = getCookieAtr('apptype')
      trackParams.userAgent = encodeURIComponent(window.navigator.userAgent)
      var isIpad = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
      var isIOSAllService = {
        isSafari:
          /Safari/i.test(window.navigator.userAgent) && !/Chrome/i.test(window.navigator.userAgent),
        isIOS: /iPhone|iPad|iPod/i.test(window.navigator.userAgent) || isIpad,
        isIphonex: /iPhone/i.test(window.navigator.userAgent) && window.screen.height >= 812,
        isMac: /Mac OS X/i.test(window.navigator.userAgent),
      }
      trackParams.platform =
        isIOSAllService.isSafari ||
        isIOSAllService.isIOS ||
        isIOSAllService.isIphonex ||
        isIOSAllService.isMac
          ? '苹果'
          : '其它'
      return trackParams
    }
    // 事件监听
    document.querySelectorAll('[data-track-params]').forEach(function (e) {
      var trackParams = dealTrackParams(e)
      var action = trackParams.action
      delete trackParams.action
      switch (action) {
        case 'click':
          e.addEventListener('click', function () {
            track(trackParams)
          })
          break
        case 'hover':
          e.addEventListener('mouseenter', function () {
            track(trackParams)
          })
          break
      }
    })
    window.addEventListener('scroll', function (e) {
      if (document.documentElement.scrollTop + document.body.scrollTop > 150) {
        $('.w-float-bar').css('opacity', 1)
      } else if (document.documentElement.scrollTop + document.body.scrollTop < 50) {
        $('.w-float-bar').css('opacity', 0)
      }
    })
    $.registerOnce('.bg-head', {
      ref: {
        bgPng: '.bg-png',
      },
      init() {
        if (document.body.offsetWidth >= 700) {
          if (this.bgPng[0]) {
            this.bgPng[0].src = LOCAL_CDN + '/img/gitmind/png/en/bg-head-mobile-3x.png'
          }
        }
      },
    })
    $.registerOnce('.service', {
      ref: {
        num: 'span',
      },
      init() {
        var _this = this
        var downloads
        window.setInterval(function () {
          downloads = parseInt(_this.num.text()) + Math.floor(Math.random(1, 5) * 15)
          _this.num.text(downloads)
        }, 800)
      },
    })
    $.registerOnce('.bg-head', {
      ref: {
        bgPng: '.bg-png',
      },
      init() {
        if (document.body.offsetWidth >= 700) {
          this.bgPng[0].src = LOCAL_CDN + '/img/gitmind/png/en/bg-head-mobile-3x.png'
        }
      },
    })
    $.registerOnce('.bg-third', {
      ref: {
        leftLi: '.main-left li',
        loading: '.gitmind-loading',
        rightImg: '.main-right img',
      },
      activeIndex: 0,
      lastIndex: 0,
      listLen: 0,
      init() {
        this.bindEvents()
        $(this.leftLi[this.activeIndex]).click()
        this.listLen = this.leftLi.length
      },
      bindEvents() {
        this.leftLi.$on('click', this.listenLiClick, this)
        this.animationEnd()
      },
      animationEnd() {
        $(this.loading).$on(
          'transitionend',
          function () {
            $(this.leftLi[(this.activeIndex + 1) % this.listLen]).click()
          },
          this
        )
      },
      listenLiClick(e) {
        this.lastIndex = this.activeIndex
        var activeIndex = $(e.currentTarget).index()
        if (activeIndex === this.lastIndex) {
          // index相同
          $(e.currentTarget).toggleClass('show')
          $(e.currentTarget).addClass('active')
        } else {
          $(this.leftLi[this.lastIndex]).removeClass('show active')
          $(e.currentTarget).addClass('show active')
          $(this.rightImg[this.lastIndex]).removeClass('show')
        }
        this.activeIndex = activeIndex
        $(this.rightImg[this.activeIndex]).addClass('show')
      },
    })

    //format long text
    $.registerOnce('.howto', {
      article: [
        'https://gitmind.cn/select-mind-map-software.html',
        'https://gitmind.cn/how-to-make-organization-chart.html',
        'https://gitmind.cn/how-to-do-flowchart.html',
      ],
      ref: {
        liEl: 'li',
      },
      init: function () {
        this.formatString('.howto-li')
        this.toArticle()
      },
      toArticle: function () {
        this.liEl.click(function (e) {
          document.getElementById(e.currentTarget.className).click()
        })
      },
      /**
       * @description 多选文本溢出格式化
       */
      formatString: function (el) {
        $(el)
          .find('.content-wrap')
          .each(function () {
            // 多行文本省略号
            var $this = $(this),
              $text = $this.find('.moreText')
            while ($text.outerHeight() > $this.height()) {
              $text.text($text.text().replace(/(\s)*([a-zA-Z0-9]+|\W)(\.\.\.)?$/, '...'))
            }
          })
      },
    })

    $.registerOnce('.gitmind-review', {
      paging: 6,
      data: {},
      page: 0,
      ref: {
        listEl: 'ul',
      },
      init: function () {
        this.loadPageData()
        this.el.$on('click', this.onClickLike, this)
      },
      onCreated() {
        this.apower = apower
      },
      onLoadData: function (list, isPrepend) {
        if (!list || !list.length) {
          return
        }

        var template =
          '<li class="review-item" data-id="{id}">' +
          '<div class="rating rating-sml" data-rating="{score}">' +
          '<div class="rating-stars"></div>' +
          '<div class="rating-time">{add_time}</div>' +
          '</div>' +
          '<div class="review-content">' +
          '<div class="review-text">' +
          '<header>{title}</header>' +
          '<i>by {name}</i>' +
          '<p>{review}</p>' +
          '</div>' +
          '<div class="review-like-group">' +
          '<div class="review-like">{approval_num}</div>' +
          '<div class="review-dislike">{oppose_num}</div>' +
          '</div>' +
          '</div>' +
          '</li>'

        for (var i = 0; i < list.length; i++) {
          var json = list[i]
          if (json.name === 'Anonymous' || !json.name) {
            json.name = apower.tr('anonymous') || json.name
          }

          var html = template.format(json)
          var item = $(html).applyCom()

          if (isPrepend) {
            this.listEl.prepend(item)
          } else {
            this.listEl.append(item)
          }
        }
      },
      loadPageData: function () {
        var post = {
          related_id: this.apower.productId,
          type: this.apower.productType,
          action: 'get_review',
          start: 0,
          page_num: this.paging,
          language: this.apower.lang,
        }
        $.ajax({
          url: 'https://support.apowersoft.com/Api/review',
          data: post,
          dataType: 'jsonp',
          jsonpCallback: 'jQueryCallback',
          cache: true,
          success: function (body) {
            this.data[this.page] = body.all_review
            this.onLoadData(this.data[this.page])
          }.bind(this),
        })
      },
      onClickLike: function (e) {
        var likeEl = $(e.target).closest('.review-like, .review-dislike')
        var isLike = likeEl.is('.review-like')
        var twoBtns = likeEl.parent().children('.review-like, .review-dislike')

        if (likeEl.length) {
          twoBtns.addClass('review-liked')
          var id = likeEl.closest('[data-id]').data('id')

          var post = {
            review_id: id,
            type: apower.productType,
            action: isLike ? 'approval' : 'oppose',
          }

          $.ajax({
            url: $.nocache('https://support.apowersoft.com/Api/review'),
            data: post,
            dataType: 'jsonp',
            success: function (body) {
              if (body.status === 'exist') {
              } else if (body.status === 'failed') {
                twoBtns.removeClass('review-liked')
              } else {
                likeEl.text((Number(likeEl.text()) || 0) + 1)
              }
            },
          })
        }
      },
    })

    /**
     * @description 多选文本溢出格式化
     */
    function formatString(el) {
      $(el)
        .find('.content-wrap')
        .each(function () {
          // 多行文本省略号
          var $this = $(this),
            $text = $this.find('.moreText')
          while ($text.outerHeight() > $this.height()) {
            $text.text($text.text().replace(/(\s)*([a-zA-Z0-9]+|\W)(\.\.\.)?$/, '...'))
          }
        })
    }
  },
})

          })
        